import { render, staticRenderFns } from "./TaskEdit.vue?vue&type=template&id=6f73114c"
import script from "./TaskEdit.vue?vue&type=script&lang=js"
export * from "./TaskEdit.vue?vue&type=script&lang=js"
import style0 from "./TaskEdit.vue?vue&type=style&index=0&id=6f73114c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports